module.exports = __webpack_public_path__ + "img/img_app_band_golf.5fbf187b.png";